module.exports = __webpack_public_path__ + "img/ic-pix.d58d4519.svg";